import { useMemo } from 'react'
import useFastSpringStore from './useFastSpringStore';
import _includes from 'lodash/includes';

export default (productId) => {
  const [{ productsInCart }] = useFastSpringStore();

  return useMemo(() => {
    return _includes(productsInCart, productId);
  }, [productsInCart])
}
